import styled, { keyframes } from "styled-components";

const stripedSlide = keyframes`
  from { background-position: 0 0; }
  to { background-position: 40px 0; }
`;

export const Pill = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  align-self: ${({ $fill }) => ($fill ? "stretch" : "auto")};
  height: ${({ theme, $fill }) =>
    $fill ? "auto" : theme.filters.height.default};
  width: ${({ $fill }) => ($fill ? "auto" : "220px")};
  flex: ${({ $fill }) => ($fill ? 1 : "none")};
  margin: ${({ theme, $fill }) => ($fill ? `0 ${theme.spacing[3]}` : "0")};
  padding: 0 20px;
  border-radius: ${({ theme }) => theme.br.pill};
  color: ${({ theme }) => theme.textLight};
  font-family: ${({ theme }) => theme.p4b.ff};
  font-size: ${({ theme }) => theme.p4b.fs};
  letter-spacing: ${({ theme }) => theme.p4b.letterSpacing};
  background-color: ${({ theme }) => theme.primary};
  background-image: repeating-linear-gradient(
    -45deg,
    ${({ theme }) => theme.primary} 0,
    ${({ theme }) => theme.primary} 14px,
    rgba(0, 0, 0, 0.22) 14px,
    rgba(0, 0, 0, 0.22) 28px
  );
  background-size: 40px 40px;
  animation: ${stripedSlide} 1.1s linear infinite;
  overflow: hidden;
  white-space: nowrap;
`;
